
import { Briefcase, Building2, ClipboardCheck, FileText, LineChart, Scale,ExclamationCircle, Calculator, Users, Building, AlertCircle, ArrowUpRight } from 'lucide-react'
import React from 'react'
import Faqs from './Faqs';
import { Link } from 'react-router-dom';
import Carousel from './Carousel';

function LandingPage() {
  const taxCards = [
    {
      icon: <ClipboardCheck size={60} className="text-black" />, 
      title: "Analyze Paperwork",
      description: "We perform a detailed analysis of your Property. Comparing it to others in the neighborhood. Making a mistake on your return can be costly."
    },
    {
      icon: <FileText size={60} className="text-black" />, 
      title: "Tax Compliance",
      description: "Ensuring all your tax filings meet the legal requirements. We help you avoid penalties and maximize deductions."
    },
    {
      icon: <Briefcase size={60} className="text-black" />, 
      title: "Financial Planning",
      description: "Strategic tax planning to help you save money and prepare for future financial goals."
    }
  ];
  
  const articles = [
    {
      image: 'images/galaxy.jpg',
      category: 'Business',
      title: 'How To Write Your Consulting Firm Mission Statements & Why It’s Important.',
    },
    {
      image: 'images/landingpage.webp',
      category: 'Product',
      title: 'What Is An Entrepreneurial Consultant? (Examples & Stories).',
    },
    {
      image: 'images/profesional.webp',
      category: 'Lifestyle',
      title: 'Personal Branding For Consultants: Be Authentic To Get More Clients.',
    },
  ];
  return (
    <div> {/* Hero Section */}
    <section
className="relative w-full h-screen flex "
style={{
backgroundImage: "url('images/landing1.jpeg')",
backgroundSize: "cover",
backgroundPosition: "center",
backgroundRepeat: "no-repeat",
}}
>
{/* Overlay */}
<div className="absolute inset-0 bg-black bg-opacity-50"></div>

{/* Content */}
<div className="relative z-10 text-white p-6 xl:pl-32  max-w-5xl pt-40">
<h1 className="text-4xl font-bold mb-4 md:text-6xl lg:text-8xl">
We help you avoid<br/> Tax blunders.
</h1>
<p className="text-lg md:text-2xl mb-6 max-w-xl">
Fully digitized services for the reliable and confidential handling of your financial details.
</p>

{/* <div className="flex flex-col md:flex-row gap-12">
  <button className="flex items-center gap-2 py-2 bg-slate-900 text-white p-3 px-6 text-lg font-semibold hover:bg-slate-800 transition">
    Get An Estimated Quote
    <ArrowUpRight size={20} />
  </button>
  
  <button className="flex items-center gap-2 bg-amber-300 text-black p-3 px-6 text-lg font-semibold hover:bg-amber-600 transition">
    Schedule A Call
    <ArrowUpRight size={20} />
  </button>
</div> */}
<div className="flex flex-col sm:flex-row gap-6 sm:gap-8 w-full justify-center md:justify-start items-center">
  {/* Get An Estimated Quote Button */}
  <Link to="/contactus">
  <button className="flex items-center gap-2 py-3 h-14 md:h-full px-6 w-64 md:w-72 bg-slate-900 text-white  md:text-lg font-semibold hover:bg-slate-800 transition duration-300">
    Get An Estimated Quote
    <ArrowUpRight size={20} />
  </button></Link>

  {/* Schedule A Call Button */}
  <Link to="/contactus">
  <button className="flex items-center gap-2 py-3 h-14 md:h-full px-6 w-52 bg-amber-300 text-black md:text-lg font-semibold hover:bg-amber-600 transition duration-300">
    Schedule A Call
    <ArrowUpRight size={20} />
  </button></Link>
</div>

<p className="text-lg md:text-2xl mt-6 max-w-2xl">
Trusted by many Businesses & Individuals, in and around GTA.
</p>

</div>
</section>

<div className="relative bg-slate-900 min-h-screen flex flex-col justify-center items-center px-6 
                before:absolute before:w-52 before:h-52 before:bg-gradient-to-br before:from-white/20 before:to-transparent before:blur-3xl before:top-10 before:right-10
                after:absolute after:w-52 after:h-52 after:bg-gradient-to-tl after:from-white/20 after:to-transparent after:blur-3xl after:bottom-10 after:left-10">

  {/* Arrow Button */}
  <div className="absolute -top-8 flex justify-center items-center w-16 h-16 sm:w-20 sm:h-20 bg-white rounded-full shadow-lg">
    <div className="absolute w-24 h-24 sm:w-28 sm:h-28 border-dotted border-2 border-white rounded-full"></div>
    <svg className="w-8 h-10 sm:w-10 sm:h-12 text-slate-900" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path fillRule="evenodd" d="M12 3a1 1 0 0 1 1 1v12.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L11 16.586V4a1 1 0 0 1 1-1z" clipRule="evenodd" />
    </svg>
  </div>

  {/* Headline */}
  <h1 className="text-center text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white max-w-3xl mt-20 sm:mt-16">
    Consulting tax is built for small business.
  </h1>

  {/* Card Section */}
  <section className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12 w-full max-w-6xl mb-12 md:mb-0 md:px-4 md:pb-20">
      {[
        {
          title: "CRA Tax Problems",
          text: "Making a mistake on your return can be costly. From missed deductions, or worse, the dreaded CRA audit.",
          icon: <AlertCircle size={80} className="text-orange-300" />,
        },
        {
          title: "Tax Preparation and Planning",
          text: "Getting the most out of your income and finances is what sets us apart. Whether you need tax preparation services.",
          icon: <Calculator size={80} className="text-orange-300" />,
        },
        {
          title: "Payroll Services",
          text: "Managing payroll may not seem like a critical task until something goes wrong. We have experts and technologies to help you.",
          icon: <Users size={80} className="text-orange-300" />,
        },
        {
          title: "Franchise Accounting",
          text: "We know that competent, consistent bookkeeping is the key to business success. Success starts when you take charge of books.",
          icon: <Building size={80} className="text-orange-300" />,
        },
      ].map((card, index) => (
        <div key={index} className="glass-card max-w-xl p-8 sm:p-10 bg-white bg-opacity-20 backdrop-blur-lg rounded-lg shadow-lg text-center border border-white/20 flex items-center gap-6">
          {card.icon}
          <div className="text-left">
            <h3 className="text-xl sm:text-2xl font-semibold text-white">{card.title}</h3>
            <p className="text-base sm:text-lg text-gray-400 mt-3">{card.text}</p>
          </div>
        </div>
      ))}
  </section>

</div>


<div className="relative  text-black py-20 px-6 xl:px-20 flex flex-col gap-12 justify-center lg:flex-row items-center lg:items-start">
      {/* Light Beam Effect */}
      <div className="absolute inset-0 bg-gradient-radial from-white/10 to-transparent md:w-96 h-96 rounded-full blur-3xl top-1/2 md:right-10 transform -translate-y-1/2 -z-10"></div>

      {/* Left Side: Text Section */}
      <div className="lg:w-1/2">
        <h1 className="text-3xl font-bold mb-4 md:text-5xl leading-tight">
          We Handle The Most Tedious Bookkeeping Tasks Of Your Business Operations
        </h1>
        <p className="text-lg text-gray-600 mt-6">
        Experienced, knowledgeable professionals in Tax Consulting. Our team of Tax Consultants is committed to saving you money by obtaining the Highest possible tax returns on your tax returns.
        </p>
        <Link to="/contactus">
        <button className="flex items-center gap-2 h-14 md:h-full  w-64 md:w-72 bg-slate-900 text-white p-3 px-6 mt-6 md:text-lg font-semibold hover:bg-slate-800 transition">
    Get An Estimated Quote
    <ArrowUpRight size={20} />
  </button></Link>
      </div>

      {/* Right Side: Tax Service Cards */}
      <div className="lg:w-1/2 xl:w-1/3 grid grid-cols-1  sm:grid-cols-2 gap-6 mt-12 lg:mt-0">
        {[
          { icon: <FileText size={36} />, number: "500+", text: "Tax Filings Handled" },
          { icon: <Scale size={36} />, number: "98%", text: "Successful Appeals" },
          { icon: <LineChart size={36} />, number: "10Y+", text: "Industry Experience" },
          { icon: <Building2 size={36} />, number: "500 K+", text: "saved in Tax Returns" }
        ].map((card, index) => (
          <div key={index} className="flex flex-col justify-center items-center bg-white/10 p-4 rounded-xl shadow-lg backdrop-blur-md text-center border border-white/20 w-44 h-44">
            <div className="text-black">{card.icon}</div>
            <h3 className="text-2xl font-bold mt-2">{card.number}</h3>
            <p className="text-sm text-gray-600">{card.text}</p>
          </div>
        ))}
      </div>
    </div>

{/* our teams */}
    <div className="bg-slate-900 px-6  xl:px-20 pt-12 pb-20 md:pb-0">
  {/* Heading */}
  <h1 className="text-center text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold text-white pt-6">
    Our <span className="text-zinc-400">Team</span>
  </h1>
  <h1 className="text-center text-lg sm:text-xl lg:text-2xl text-gray-400 mt-6 mb-3">
    "Together, we combine our strengths and expertise to create innovative <br className="hidden md:block"/> solutions and achieve extraordinary results."
  </h1>

  {/* Team Section */}
  <div className="flex flex-col md:flex-row justify-center xl:mt-20 2xl:px-60">
    
    {/* First Member */}
    <div className="flex flex-col xl:flex-row items-center gap-6 md:gap-12 pb-12 md:pb-40 xl:pb-80 rounded-2xl">
      <div className="flex justify-center md:justify-start">
        <img className="w-48 sm:w-64 lg:w-[300px] rounded-xl" src="images/accountant1.png" alt="Pankaj Aggarwal" />
      </div>
      <div className="text-center md:text-left px-4 sm:px-0">
        <p className="text-white text-2xl sm:text-3xl font-bold mt-3">Pankaj Aggarwal</p>
        <p className="text-white">Tax Consultant</p>
        <p className="text-white font-semibold">"Help to reduce your taxes and Maximize your refund."</p>
        <p className="max-w-2xl text-white mt-6 mb-6">
           Pankaj Aggarwal is the driving force behind Aggarwal Tax and Accounting Services. With over a decade of experience, he specializes in tax planning, compliance, and financial consulting for individuals and businesses.
        </p>
      </div>
    </div>

    {/* Second Member */}
    <div className="flex flex-col xl:flex-row-reverse items-center gap-6 md:gap-12 xl:pt-40 xl:mb-20 rounded-2xl">
      <div className="flex justify-center md:justify-end">
        <img className="w-48 sm:w-64 lg:w-[300px] rounded-xl" src="images/accountant2.jpg" alt="Rishab Aggarwal" />
      </div>
      <div className="text-center md:text-right px-4 sm:px-0">
        <p className="text-white text-2xl sm:text-3xl font-bold mt-3">Rishab Aggarwal</p>
        <p className="text-white">Junior Accountant</p>
        <p className="max-w-2xl text-white mt-6">
          Rishab Aggarwal is a dedicated Junior Accountant at Aggarwal Tax and Accounting Services, specializing in tax preparation, bookkeeping, and financial reporting. With a strong foundation in accounting principles and a commitment to accuracy, he assists individuals and businesses in managing their financial needs efficiently.
        </p>
      </div>
    </div>

  </div>
</div>


<div className='px-2 md:p-10 xl:p-32  '>
<h1 className=" flex text-2xl font-bold mb-4 md:text-5xl xl:text-5xl mt-12 md:mt-0 leading-tight  justify-center  text-center  ">
          How Consultic tax can help your business<br/>  Tax Solutions for Your Business
        </h1>
        <div className="flex flex-col  items-center mt-12">
      
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 justify-center items-center">
        {taxCards.map((card, index) => (
          <div key={index} className="bg-white border border-gray-200 p-4 rounded-lg  text-center md:w-80 h-80 flex flex-col justify-between">
          <div className=" flex justify-start">
  <div className="w-20 h-20 flex items-center justify-center rounded-full ">
    {card.icon}
  </div>
</div>
   <p className="font-bold text-xl mb-2 text-start mt-12 ">{card.title}</p>
   <p className="text-md text-gray-600 flex-1 text-start">{card.description}</p>
 </div>
        ))}
      </div>
    </div>
  </div>

{/* pricing cards */}
<div className="max-w-6xl mx-auto px-4 py-12 ">
      <h1 className="text-2xl font-bold  md:text-5xl xl:text-5xl text-center mb-20 text-slate-900">
        We Offer the Best Cost-Effective<br/> Tax Consultation Solutions.
      </h1>

      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-8">
        {[
          {
            title: "Personal Tax",
            // time: "1 Hour Consultation",
            price: "$50",
            points: [
              "Expert personal tax filing assistance",
              "Personal Income Tax Filling ​​",
              "Tax Filling for Students",
              "E-file",
              "​Tax Planning and Advisory",
            ],
          },
          {
            title: "Corporate Tax Return",
            // time: "1 Hour Consultation",
            price: "$500",
            points: [
              // "Accurate and detailed corporate tax filing",
              "Business Income Tax Filling",
              "GST/HST tax returns Filing",
              "​Incorporation and Business Registration",
              "Financial Reporting and Analysis",
              "Consulting Services"
            ],
          },
          {
            title: "Miscelleneous Services",
            // time: "1 Hour Consultation",
            price: "$20 to $300",
            points: [
              "Newcomer Benefits",
              "Child Benefits",
              "Apply HST for Uber",
              "Uber Eats Tax",
              "Uber Ride with HST",
              "Open new Corporation"
            ],
          },
        ].map((service, index) => (
          <div
            key={index}
            className="bg-white  p-3 md:p-8 rounded-lg shadow-lg text-left border border-gray-300 hover:shadow-gray-900 transition"
          >
            <h3 className="text-2xl font-semibold text-slate-900 mb-3">
              {service.title}
            </h3>
            <p className="text-lg text-gray-700">{service.time}</p>
            <p className="text-2xl font-bold text-slate-800">{service.price}</p>
        <Link to="/contactus">
        <button className="flex items-center mt-6 rounded-lg gap-2 bg-slate-900 text-white p-3 md:px-6 text-lg font-semibold hover:bg-slate-800 transition">
    Get An Estimated Quote
    <ArrowUpRight size={20} />
  </button></Link>
            <ul className="mt-6 text-lg text-gray-700 text-left space-y-2">
              {service.points.map((point, i) => (
                <li key={i} className="flex items-start gap-2">
                  <span className="text-xl">✔</span>
                  <span className="w-full">{point}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>

<Carousel/>

<Faqs/>
    <section
  className="relative bg-cover bg-center py-24 flex items-cente mt-20"
  style={{ backgroundImage: "url('images/profesional.webp')" }}
>
  <div className="absolute inset-0 bg-black bg-opacity-50"></div>

  <div className="relative z-10 container mx-auto text-white px-6 flex flex-col md:flex-row  items-center justify-center">
    <div className="md:w-1/2">
      <p className="text-2xl md:text-4xl xl:text-5xl max-w-2xl mb-6  font-semibold">
       Join Us today and let us help you to grow your business.
      </p>
    </div>

    <div className="w-full md:w-2/3 lg:w-1/2 xl:w-1/3 mx-auto">
  <div className="flex flex-col sm:flex-row items-center bg-white rounded-lg overflow-hidden shadow-md">
    <input
      type="text"
      placeholder="Enter your email"
      className="w-full sm:w-auto flex-1 p-3 text-black outline-none border-b sm:border-none"
    />
    <Link to="/contactus">
      <button className="bg-slate-900 text-white px-6 py-3 xl:w-40 rounded-md m-3 flex items-center gap-2 hover:bg-slate-800 transition">
        Get Quote
        <ArrowUpRight size={20} />
      </button>
    </Link>
  </div>
</div>


    
  </div>
</section>


</div>
  )
}

export default LandingPage


// import { Briefcase, Building2, ClipboardCheck, FileText, LineChart, Scale,ExclamationCircle, Calculator, Users, Building, AlertCircle, ArrowUpRight } from 'lucide-react'
// import React from 'react'
// import ImageCarousel from './ImageCarousel'
// import Faqs from './Faqs';

// function LandingPage() {
//   const taxCards = [
//     {
//       icon: <ClipboardCheck size={60} className="text-black" />, 
//       title: "Analyze Paperwork",
//       description: "We perform a detailed analysis of your Property. Comparing it to others in the neighborhood. Making a mistake on your return can be costly."
//     },
//     {
//       icon: <FileText size={60} className="text-black" />, 
//       title: "Tax Compliance",
//       description: "Ensuring all your tax filings meet the legal requirements. We help you avoid penalties and maximize deductions."
//     },
//     {
//       icon: <Briefcase size={60} className="text-black" />, 
//       title: "Financial Planning",
//       description: "Strategic tax planning to help you save money and prepare for future financial goals."
//     }
//   ];
  
//   const articles = [
//     {
//       image: 'images/galaxy.jpg',
//       category: 'Business',
//       title: 'How To Write Your Consulting Firm Mission Statements & Why It’s Important.',
//     },
//     {
//       image: 'images/landingpage.webp',
//       category: 'Product',
//       title: 'What Is An Entrepreneurial Consultant? (Examples & Stories).',
//     },
//     {
//       image: 'images/profesional.webp',
//       category: 'Lifestyle',
//       title: 'Personal Branding For Consultants: Be Authentic To Get More Clients.',
//     },
//   ];
//   return (
//     <div> {/* Hero Section */}
//     <section
// className="relative w-full h-screen flex "
// style={{
// backgroundImage: "url('images/landing1.jpeg')",
// backgroundSize: "cover",
// backgroundPosition: "center",
// backgroundRepeat: "no-repeat",
// }}
// >
// {/* Overlay */}
// <div className="absolute inset-0 bg-black bg-opacity-50"></div>

// {/* Content */}
// <div className="relative z-10 text-white p-6 xl:pl-32  max-w-5xl pt-40">
// <h1 className="text-4xl font-bold mb-4 md:text-8xl">
// We help you avoid<br/> Tax blunders.
// </h1>
// <p className="text-lg md:text-2xl mb-6 max-w-xl">
// Fully digitized services for the reliable and confidential handling of your financial details.
// </p>
// <div className="flex gap-12">
//   <button className="flex items-center gap-2 bg-slate-900 text-white p-3 px-6 text-lg font-semibold hover:bg-slate-800 transition">
//     Get An Estimated Quote
//     <ArrowUpRight size={20} />
//   </button>
  
//   <button className="flex items-center gap-2 bg-amber-300 text-black p-3 px-6 text-lg font-semibold hover:bg-amber-600 transition">
//     Schedule A Call
//     <ArrowUpRight size={20} />
//   </button>
// </div>
// <p className="text-lg md:text-2xl mt-6 max-w-xl">
// Trusted by many Businesses in and around GTA.
// </p>
// {/* <div className='flex gap-6 mt-6'>
// <img src='images/airbnb.png'></img>
// <img src='images/amazon.png'></img>
// <img src='images/fedex.png'></img>
// <img src='images/google.png'></img>
// <img src='images/micro.png'></img>
// </div> */}
// </div>
// </section>
// <div className="relative bg-slate-900 min-h-screen flex flex-col justify-center items-center px-6 
//                 before:absolute before:w-52 before:h-52 before:bg-gradient-to-br before:from-white/20 before:to-transparent before:blur-3xl before:top-10 before:right-10
//                 after:absolute after:w-52 after:h-52 after:bg-gradient-to-tl after:from-white/20 after:to-transparent after:blur-3xl after:bottom-10 after:left-10">

//   {/* Arrow Button at Top */}
//   <div className="absolute -top-6 flex justify-center items-center w-20 h-20 bg-white rounded-full shadow-lg">
//     <div className="absolute w-28 h-28 border-dotted border-2 border-white rounded-full"></div>
//     <svg className="w-10 h-12 text-slate-900" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
//       <path fillRule="evenodd" d="M12 3a1 1 0 0 1 1 1v12.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 1.414-1.414L11 16.586V4a1 1 0 0 1 1-1z" clipRule="evenodd" />
//     </svg>
//   </div>

//   <h1 className="text-center text-5xl lg:text-6xl text-white max-w-3xl mt-10">
//     Consulting tax is built for small business.
//   </h1>

//   <section className="grid grid-cols-1 lg:grid-cols-2 gap-10 mt-12">
//       {[
//         {
          
//           title: "CRA Tax Problems",
//           text: "Making a mistake on your return can be costly. From missed deductions, or worse, the dreaded CRA audit.",
//           icon: <AlertCircle size={100} className="text-orange-300" />,
//         },
//         {
//           title: "Tax Preparation and Planning",
//           text: "Getting the most out of your income and finances is what sets us apart. Whether you need tax preparation services",
//           icon: <Calculator size={100} className="text-orange-300" />,
//         },
//         {
//           title: "Payroll Services",
//           text: "Managing payroll may not seem like a critical task until something goes wrong. We have experts and technologies to help you.",
//           icon: <Users size={100} className="text-orange-300" />,
//         },
//         {
//           title: "Franchise Accounting",
//           text: "We know that competent, consistent bookkeeping is the key to business success. Success starts when you take charge of books.",
//           icon: <Building size={100} className="text-orange-300" />,
//         },
//       ].map((card, index) => (
//         <div
//           key={index}
//           className="glass-card max-w-xl p-12 bg-white bg-opacity-20 backdrop-blur-lg rounded-lg shadow-lg text-center border border-white/20 flex items-center space-x-4"
//         >
//           <div className="flex   items-center gap-12 text-left">
//           {card.icon}
// <div>
// <h3 className="text-2xl font-semibold text-white">{card.title}</h3>
//             <p className="text-lg text-gray-400 mt-4">{card.text}</p>
// </div>
            
//           </div>
//         </div>
//       ))}
//     </section>

// </div>

// <div className="relative  text-black py-20 px-6 lg:px-20 flex flex-col justify-center lg:flex-row items-center lg:items-start">
//       {/* Light Beam Effect */}
//       <div className="absolute inset-0 bg-gradient-radial from-white/10 to-transparent w-96 h-96 rounded-full blur-3xl top-1/2 right-10 transform -translate-y-1/2 -z-10"></div>

//       {/* Left Side: Text Section */}
//       <div className="lg:w-1/2">
//         <h1 className="text-4xl lg:text-5xl font-bold leading-tight">
//           We Handle The Most Tedious Bookkeeping Tasks Of Your Business Operations
//         </h1>
//         <p className="text-lg text-gray-600 mt-6">
//           Experienced, knowledgeable professionals in Property Tax Consulting.  
//           Our team of Property Tax Consultants is committed to saving you money  
//           by obtaining the lowest possible assessed value for your commercial  
//           or residential properties.
//         </p>
//         <button className="flex items-center gap-2 bg-slate-900 text-white p-3 px-6 mt-6 text-lg font-semibold hover:bg-slate-800 transition">
//     Get An Estimated Quote
//     <ArrowUpRight size={20} />
//   </button>
//       </div>

//       {/* Right Side: Tax Service Cards */}
//       <div className="lg:w-1/4 grid grid-cols-1  sm:grid-cols-2 gap-6 mt-12 lg:mt-0">
//         {[
//           { icon: <FileText size={36} />, number: "500+", text: "Tax Filings Handled" },
//           { icon: <Scale size={36} />, number: "98%", text: "Successful Appeals" },
//           { icon: <LineChart size={36} />, number: "10Y+", text: "Industry Experience" },
//           { icon: <Building2 size={36} />, number: "250M+", text: "Property Value Saved" }
//         ].map((card, index) => (
//           <div key={index} className="flex flex-col justify-center items-center bg-white/10 p-4 rounded-xl shadow-lg backdrop-blur-md text-center border border-white/20 w-44 h-44">
//             <div className="text-black">{card.icon}</div>
//             <h3 className="text-2xl font-bold mt-2">{card.number}</h3>
//             <p className="text-sm text-gray-600">{card.text}</p>
//           </div>
//         ))}
//       </div>
//     </div>

// <ImageCarousel/>

// <div className=' md:p-10 xl:p-32 '>
// <h1 className=" flex text-4xl lg:text-5xl font-bold leading-tight  justify-center  text-center  ">
//           How Consultic tax can help your business<br/>  Tax Solutions for Your Business
//         </h1>
//         <div className="flex flex-col  items-center mt-12">
      
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-6 justify-center items-center">
//         {taxCards.map((card, index) => (
//           <div key={index} className="bg-white border border-gray-200 p-4 rounded-lg  text-center w-80 h-80 flex flex-col justify-between">
//           <div className=" flex justify-start">
//   <div className="w-20 h-20 flex items-center justify-center rounded-full ">
//     {card.icon}
//   </div>
// </div>
//    <p className="font-bold text-xl mb-2 text-start mt-12 ">{card.title}</p>
//    <p className="text-md text-gray-600 flex-1 text-start">{card.description}</p>
//  </div>
//         ))}
//       </div>
//     </div>
//   </div>

// {/* pricing cards */}
// <div className="max-w-6xl mx-auto px-4 py-12">
//       <h1 className="text-4xl  md:text-6xl font-bold text-center mb-20 text-slate-900">
//         We Offer the Best Cost-Effective<br/> Tax Consultation Solutions.
//       </h1>

//       <div className="grid md:grid-cols-3 gap-8">
//         {[
//           {
//             title: "Personal Tax",
//             // time: "1 Hour Consultation",
//             price: "$50",
//             points: [
//               "Expert personal tax filing assistance",
//               "Personal Income Tax Filling ​​",
//               "Tax Filling for Students",
//               "E-file",
//               "​Tax Planning and Advisory",
//             ],
//           },
//           {
//             title: "Corporate Tax Return",
//             // time: "1 Hour Consultation",
//             price: "$500",
//             points: [
//               // "Accurate and detailed corporate tax filing",
//               "Business Income Tax Filling",
//               "GST/HST tax returns Filing",
//               "​Incorporation and Business Registration",
//               "Financial Reporting and Analysis",
//               "Consulting Services"
//             ],
//           },
//           {
//             title: "Miscelleneous Services",
//             // time: "1 Hour Consultation",
//             price: "$20 to $300",
//             points: [
//               "Newcomer Benefits",
//               "Child Benefits",
//               "Apply HST for Uber",
//               "Uber Eats Tax",
//               "Uber Ride with HST",
//               "Open new Corporation"
//             ],
//           },
//         ].map((service, index) => (
//           <div
//             key={index}
//             className="bg-white md:p-8 rounded-lg shadow-lg text-left border border-gray-300 hover:shadow-gray-900 transition"
//           >
//             <h3 className="text-2xl font-semibold text-slate-900 mb-3">
//               {service.title}
//             </h3>
//             <p className="text-lg text-gray-700">{service.time}</p>
//             <p className="text-2xl font-bold text-slate-800">{service.price}</p>
//             <button className="flex items-center mt-6 rounded-lg gap-2 bg-slate-900 text-white p-3 px-6 text-lg font-semibold hover:bg-slate-800 transition">
//     Get An Estimated Quote
//     <ArrowUpRight size={20} />
//   </button>
//             <ul className="mt-6 text-lg text-gray-700 text-left space-y-2">
//               {service.points.map((point, i) => (
//                 <li key={i} className="flex items-start gap-2">
//                   <span className="text-xl">✔</span>
//                   <span className="w-full">{point}</span>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         ))}
//       </div>
//     </div>

// <Faqs/>
// {/* card & content */}
// <div className="py-16 px-6 md:px-12 lg:px-40">
//       <h1 className="text-3xl md:text-4xl font-bold text-center mb-8">
//         Take a look at the latest articles from <span className="text-amber-500">Consultic Tax</span>
//       </h1>

//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//         {articles.map((article, index) => (
//           <div
//             key={index}
//             className="bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-2xl transition duration-300"
//           >
//             <img src={article.image} alt="Article" className="w-full h-64 object-cover" />
//             <div className="p-6">
//               <div className="inline-block bg-slate-500 text-white px-4 py-1 text-sm font-semibold rounded-md mb-4">
//                 {article.category}
//               </div>
//               <p className="text-lg font-semibold text-gray-900">{article.title}</p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>

//     <section
//   className="relative bg-cover bg-center py-24 flex items-cente mt-20"
//   style={{ backgroundImage: "url('images/profesional.webp')" }}
// >
//   <div className="absolute inset-0 bg-black bg-opacity-50"></div>

//   <div className="relative z-10 container mx-auto text-white px-6 flex flex-col md:flex-row  items-center justify-center">
//     <div className="md:w-1/2">
//       <p className="text-2xl md:text-5xl max-w-xl mb-6  font-semibold">
//        Join Us today and let us help you to grow your business.
//       </p>
//     </div>

//     <div className="md:w-1/3 w-full">
//       <div className="flex items-center bg-white rounded-lg overflow-hidden">
//         <input
//           type="text"
//           placeholder="Enter your email"
//           className="w-full p-3 text-black outline-none"
//         />
//         <button className="bg-slate-900 text-white px-6 w-60 rounded-md m-3 py-3 flex items-center gap-2 hover:bg-slate-800 transition">
//           Get Quote
//           <ArrowUpRight size={20} />
//         </button>
//       </div>
//     </div>
//   </div>
// </section>


// </div>
//   )
// }

// export default LandingPage


